<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="6" md="8">
        <h1 class="pt-5 mb-2">Do Not Sell or Share My Personal Information</h1>
        <p>
          <br />
          Mosaic ATM, Inc. does not sell or share personal information as
          contemplated by the CCPA and, therefore, we do not offer an opt-out
          mechanism.
        </p>
        <p>
          While we do not sell or share any personal information, we do provide
          certain usage data to advertising partners to enable us to provide you
          with interest-based advertising. If you prefer not to receive
          interest-based advertising, please opt out by managing your cookie
          preferences, via your account settings.
        </p>
        <p>
          For more information, please see our
          <router-link to="/privacy">Privacy Policy</router-link>.
        </p>
        <h1 class="pt-5 mb-2">
          Limit the Use of My Sensitive Personal Information
        </h1>
        <p>
          The Airport Viewer website/service does not collect any sensitive
          personal information as contemplated by the CCPA. For more
          information, please see our
          <router-link to="/privacy">Privacy Policy</router-link>.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  layout: 'landing'
}
</script>
